import request from "@/utils/request";
export const queryPage = "/icps/system/sign/dataCollection/contract/QueryPage";
export const batchUpdateOrDelete =
  "/icps/system/sign/dataCollection/contract/deletes"; //启用禁用
export const updateSortNum = "";
export const saveOrUpdate =
  "/icps/system/sign/dataCollection/contractBase/saveOrUpdate";
export const Download =
  "/icps/system/sign/dataCollection/contract/exportList";
export function engineeringManagementQueryPage(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/QueryPage",
    method: "post",
    data,
  });
}
export function getListByStation(data) {
  //根据站点获取管控业务点数据
  return request({
    url: "/icps/system/sign/basics/process/getListByStation",
    method: "post",
    data,
  });
}
export function contractSaveOrUpdate(data) {
  //根据站点获取管控业务点数据
  return request({
    url: "/icps/system/sign/dataCollection/contract/saveOrUpdate",
    method: "post",
    data,
  });
}
export function contractQueryDetailById(data) {
  //获取合同详情
  return request({
    url: "/icps/system/sign/dataCollection/contract/queryDetailById",
    method: "post",
    data,
  });
}
export function riseInPriceQueryOneByid(data) {
  //查询调价列表
  return request({
    url: "/icps/system/sign/dataCollection/contractProduct/getListByPid",
    method: "post",
    data,
  });
}
export function queryStationsByID(data) {
  //查询混凝土调价站点列表
  return request({
    url: "/icps/system/sign/dataCollection/contract/queryStationsByID",
    method: "post",
    data,
  });
}
export function QueryPageBystationId(data) {
  //查询站点调价详情： 查询多一个站点
  return request({
    url: "/icps/system/sign/dataCollection/PumpPriceLog/QueryPageBystationId",
    method: "post",
    data,
  });
}
export function QueryOneByid(data) {
  //查询调价详情
  return request({
    url: "/icps/system/sign/dataCollection/contractRawMoney/QueryPage",
    method: "post",
    data,
  });
}
export function contractRawMoneySave(data) {
  //原物料合同管理-新增原物料调价： 选择时间参数哪里多一个站点
  return request({
    url: "/icps/system/sign/dataCollection/contractRawMoney/save",
    method: "post",
    data,
  });
}
export function contractRawMoneyDeletes(data) {
  //原物料合同管理-删除调价
  return request({
    url: "/icps/system/sign/dataCollection/contractRawMoney/deletes",
    method: "post",
    data,
  });
}
export function contractAccountGetDetail(data) {
  //开户信息详情
  return request({
    url: "/icps/system/sign/dataCollection/contractAccount/getDetail",
    method: "post",
    data,
  });
}
export function contractAccountSave(data) {
  //保存开户信息
  return request({
    url: "/icps/system/sign/dataCollection/contractAccount/save",
    method: "post",
    data,
  });
}
export function getRawContractsByRawId(data) {
  //根据原物料名称id获取原物料合同
  return request({
    url: "/icps/system/sign/dataCollection/contract/getRawContractsByRawId",
    method: "post",
    data,
  });
}
export function PumpPriceLogQueryPage(data) {
  //设备外包：合同类型-泵管的价格列表
  return request({
    url: "/icps/system/sign/dataCollection/PumpPriceLog/QueryPage",
    method: "post",
    data,
  });
}
export function PumpPriceLogSave(data) {
  //设备外包：合同类型-泵管的价格设置用
  return request({
    url: "/icps/system/sign/dataCollection/PumpPriceLog/save",
    method: "post",
    data,
  });
}
export function PumpPriceLogGetDetail(data) {
  //设备外包：合同类型-泵管的价格列表中查看详情查询
  return request({
    url: "/icps/system/sign/dataCollection/PumpPriceLog/getDetail",
    method: "post",
    data,
  });
}
export function PumpPriceLogDeletes(data) {
  //设备外包：合同类型-泵管的价格列表删除数据
  return request({
    url: "/icps/system/sign/dataCollection/PumpPriceLog/deletes",
    method: "post",
    data,
  });
}
export function queryUserIsUse(data) {
  //设备外包：合同类型-泵管的价格列表删除数据
  return request({
    url: "/icps/system/sign/dataCollection/contract/queryUserIsUse",
    method: "post",
    data,
  });
}
export function queryContractNumber(data) { //判断合同唯一性
  return request({
    url: '/icps/system/sign/dataCollection/contract/queryContractNumber',
    method: 'post',
    data
  })
}
export function contractProductgetListByPid(data) { //根据原物料合同id查询对应的原物料list
  return request({
    url: '/icps/system/sign/dataCollection/contractProduct/getListByPid',
    method: 'post',
    data
  })
}
